import NextYear from "../../images/icon-calendar/nextYear.svg";
import BackYear from "../../images/icon-calendar/backYear.svg";
import NextMonth from "../../images/icon-calendar/nextMonth.svg";
import BackMonth from "../../images/icon-calendar/backMonth.svg";
import React from "react";
import { Calendar } from "react-calendar";
import "./CalendarCustom.scss";
import { Drawer } from "antd";

const CalendarCustom = ({
  openCalendar,
  typeCalendar,
  setValue,
  valueCalendar,
  setOpenCalendar,
  minDate,
}) => {
  const drawerStyles = {
    header: {
      display: "none",
      borderBottom: `1px solid red`,
    },
    body: {
      padding: 0,
    },
  };

  const onClose = () => {
    setOpenCalendar(false);
  };

  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const formatMonthYear = (locale, date) => {
    const monthYear = date.toLocaleString(locale, {
      month: "long",
      year: "numeric",
    });
    return capitalizeFirstLetter(monthYear);
  };

  return (
    <Drawer
      classNames="p-0"
      title="Basic Drawer"
      placement="bottom"
      closable={false}
      onClose={onClose}
      open={openCalendar}
      styles={drawerStyles}
    >
      <div className="z-50 bg-[#3884D8] calendar-custom">
        <div className="bg-white flex items-center justify-center relative py-5 px-2">
          <div className="font-semibold text-[20px]">
            {typeCalendar === "DepartDate" ? "Ngày đi" : "Ngày về"}
          </div>
        </div>
        <Calendar
          onChange={setValue}
          onClose
          value={valueCalendar}
          formatMonthYear={formatMonthYear}
          nextLabel={<img src={NextMonth} alt="" />}
          prevLabel={<img src={BackMonth} alt="" />}
          next2Label={<img src={NextYear} alt="" />}
          prev2Label={<img src={BackYear} alt="" />}
          minDate={minDate}
          locale="vi"
        />
      </div>
    </Drawer>
  );
};

export default CalendarCustom;
